var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchCombo"},[_c('topNav',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('commonInput',{attrs:{"btntxt":'开票'},on:{"commitCarNum":_vm.searchCombo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40205c17","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my/electronicInvoice/hzhospital.vue
// module id = null
// module chunks = 